// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/integrationpb/v1/integration.proto (package unacast.boundaries.integrationpb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message unacast.boundaries.integrationpb.v1.Snowflake
 */
export class Snowflake extends Message<Snowflake> {
  /**
   * @generated from field: string service_account = 1;
   */
  serviceAccount = "";

  constructor(data?: PartialMessage<Snowflake>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.integrationpb.v1.Snowflake";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "service_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Snowflake {
    return new Snowflake().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Snowflake {
    return new Snowflake().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Snowflake {
    return new Snowflake().fromJsonString(jsonString, options);
  }

  static equals(a: Snowflake | PlainMessage<Snowflake> | undefined, b: Snowflake | PlainMessage<Snowflake> | undefined): boolean {
    return proto3.util.equals(Snowflake, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.integrationpb.v1.BigQuery
 */
export class BigQuery extends Message<BigQuery> {
  /**
   * List of emails (user emails or service account emails)
   * Service accounts are detected by the .iam.gserviceaccount.com suffix
   *
   * @generated from field: repeated string emails = 2;
   */
  emails: string[] = [];

  constructor(data?: PartialMessage<BigQuery>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.integrationpb.v1.BigQuery";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "emails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BigQuery {
    return new BigQuery().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BigQuery {
    return new BigQuery().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BigQuery {
    return new BigQuery().fromJsonString(jsonString, options);
  }

  static equals(a: BigQuery | PlainMessage<BigQuery> | undefined, b: BigQuery | PlainMessage<BigQuery> | undefined): boolean {
    return proto3.util.equals(BigQuery, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.integrationpb.v1.Integration
 */
export class Integration extends Message<Integration> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from oneof unacast.boundaries.integrationpb.v1.Integration.data
   */
  data: {
    /**
     * @generated from field: unacast.boundaries.integrationpb.v1.Snowflake snowflake = 5;
     */
    value: Snowflake;
    case: "snowflake";
  } | {
    /**
     * @generated from field: unacast.boundaries.integrationpb.v1.BigQuery bigquery = 6;
     */
    value: BigQuery;
    case: "bigquery";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Integration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.integrationpb.v1.Integration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "snowflake", kind: "message", T: Snowflake, oneof: "data" },
    { no: 6, name: "bigquery", kind: "message", T: BigQuery, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Integration {
    return new Integration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Integration {
    return new Integration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Integration {
    return new Integration().fromJsonString(jsonString, options);
  }

  static equals(a: Integration | PlainMessage<Integration> | undefined, b: Integration | PlainMessage<Integration> | undefined): boolean {
    return proto3.util.equals(Integration, a, b);
  }
}

